export default {
    apiKey: "AIzaSyDWWV4Us-nAaamMtuR1mLzG-NvzgPqAEx0",
    authDomain: "mutualthoughts-c997d.firebaseapp.com",
    databaseURL: "https://mutualthoughts-c997d.firebaseio.com",
    projectId: "mutualthoughts-c997d",
    storageBucket: "mutualthoughts-c997d.appspot.com",
    messagingSenderId: "623302637654",
    appId: "1:623302637654:web:6211163a82ce5fc65123f7",
    measurementId: "G-289G6992GT"
}